module.exports = __webpack_public_path__ + "static/media/transgender.b91e2f09.svg";